import window from "global/window";

function waitForGlobal(name: string, timeout = 30000) {
  return new Promise<void>((resolve, reject) => {
    let waited = 0;

    function wait(interval: number) {
      setTimeout(() => {
        waited += interval;
        // some logic to check if script is loaded
        // usually it something global in window object
        // @ts-expect-error Element implicitly has an 'any' type
        if (window[name] !== undefined) {
          return resolve();
        }
        if (waited >= timeout * 1000) {
          return reject({ message: "Timeout" });
        }
        wait(interval * 2);
      }, interval);
    }

    wait(30);
  });
}

export default waitForGlobal;
